module.exports = __webpack_public_path__ + "static/media/brackevapen.d4b8e0b0.png";